import React from 'react';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {InspectionForm} from 'src/pages/Modules/Inspections/shared/InspectionForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const InspectionCreatePage: React.FC = () => (
  <ContentWrapper featureFlag={FeatureFlagEnum.Inspections}>
    <InspectionForm mode="create" />
  </ContentWrapper>
);

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.InspectionsCreate(),
  element: <InspectionCreatePage />,
  module: ModuleEnum.Inspections,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
